import React, { useState } from "react";
import "./RateReview.css";

function RateReview() {
  const [reviews, setReviews] = useState([
    { user: "Alice", rating: 5, review: "Amazing course! Learned a lot." },
    { user: "Bob", rating: 4, review: "Good content, but could use more examples." },
  ]);
  const [newReview, setNewReview] = useState("");
  const [newRating, setNewRating] = useState(0);

  const handleSubmitReview = () => {
    if (newReview.trim() && newRating > 0) {
      setReviews([...reviews, { user: "You", rating: newRating, review: newReview }]);
      setNewReview("");
      setNewRating(0);
    }
  };

  return (
    <div className="rate-review-container">
      <div className="reviews-section">
        {reviews.map((review, index) => (
          <div key={index} className="review">
            <strong>{review.user}</strong>
            <p>
              {"★".repeat(review.rating)}{" "}
              {"☆".repeat(5 - review.rating)}
            </p>
            <p>{review.review}</p>
          </div>
        ))}
      </div>
      <div className="add-review">
        <div className="rating">
          {[1, 2, 3, 4, 5].map((star) => (
            <span
              key={star}
              className={newRating >= star ? "star active" : "star"}
              onClick={() => setNewRating(star)}
            >
              ★
            </span>
          ))}
        </div>
        <textarea
          placeholder="Write your review..."
          value={newReview}
          onChange={(e) => setNewReview(e.target.value)}
        />
        <button onClick={handleSubmitReview}>Submit Review</button>
      </div>
    </div>
  );
}

export default RateReview;
